// @flow

import * as React from "react"
import Modal from "react-modal"
import {withTranslation} from "react-i18next"
import {connect} from "react-redux"

import PriceInput from "../price-input"
import Icon from "../icon"
import {toDinero} from "../../util"
import Config from "../../config"
import {createShopProductItems} from "../../actions/shop"
import type {
  ShopState,
  SearchItem,
  Dispatch,
  State as ReduxState,
} from "../../types"

type Props = {
  +t: any,
  +babyToken: string,
  +shop: ShopState,
  +dispatch: Dispatch,
  +onClose: () => void,
  +searchItem: SearchItem,
}

type ShopProductEdit = ShopProduct & {
  selected: boolean,
  original: ShopProduct,
}

type State = {
  items: ShopProductEdit[],
}

class ShopAdminShopProductsModal extends React.Component<Props, State> {
  handleToggleSelected: (id: number) => void
  handlePartsChange: (id: number, parts: number) => void
  handleSave: (SyntheticEvent<*>) => void
  renderShopProduct: (a: ShopProduct) => void
  handleUpdatePrice: (number, string, string) => void

  constructor(props: Props) {
    super(props)

    Modal.setAppElement("#app")

    this.state = {
      items: props.searchItem.shopProducts.map((shopProduct) => ({
        ...shopProduct,
        selected: false,
        original: shopProduct,
      })),
    }

    this.handleSave = this.handleSave.bind(this)
    this.renderShopProduct = this.renderShopProduct.bind(this)
  }

  unselectedAllItems() {
    return this.setState({
      items: [
        ...this.state.items.map((shopProduct) => ({
          ...shopProduct,
          selected: false,
        })),
      ],
    })
  }

  handleToggleSelected(id: number) {
    return this.setState({
      items: [
        ...this.state.items.map((shopProduct) => {
          if (shopProduct.id == id) {
            return {...shopProduct, selected: !shopProduct.selected}
          }
          return shopProduct
        }),
      ],
    })
  }

  handlePartsChange(id: number, parts: number) {
    return this.setState({
      items: [
        ...this.state.items.map((shopProduct) => {
          if (shopProduct.id == id) {
            return {...shopProduct, parts}
          }
          return shopProduct
        }),
      ],
    })
  }

  handleUpdatePrice(id: number, property: string, value: string) {
    return this.setState({
      items: [
        ...this.state.items.map((shopProduct) => {
          if (shopProduct.id == id) {
            return {...shopProduct, [property]: value}
          }
          return shopProduct
        }),
      ],
    })
  }

  handleSave(e: SyntheticEvent<*>) {
    e.preventDefault()
    const {dispatch, babyToken, searchItem} = this.props
    const selectedItems = [...this.state.items]
      .filter((shopProduct) => shopProduct.selected)
      .map((shopProduct) => {
        shopProduct = {...shopProduct}
        delete shopProduct.original
        delete shopProduct.media
        return shopProduct
      })
    dispatch(createShopProductItems(babyToken, searchItem.id, selectedItems))
    this.unselectedAllItems()
    // onClose()
  }

  renderCheckbox(id) {
    const iconName =
      this.state.items.find(
        (shopProduct) => shopProduct.id == id && shopProduct.selected
      ) !== undefined
        ? "icon-checkbox-checked"
        : "icon-checkbox-unchecked"
    return (
      <button
        className="btn btn-icon item-check"
        onClick={() => this.handleToggleSelected(id)}
      >
        <Icon name={iconName} />
      </button>
    )
  }

  renderShopProduct(shopProduct) {
    const {t} = this.props
    const media =
      shopProduct.media && shopProduct.media.length
        ? shopProduct.media[0]
        : null
    return (
      <div
        key={`sp-${shopProduct.id}`}
        className="d-flex justify-content-between mb-4"
      >
        <div className="shop-item-media-list-image w-25">
          {media ? <img src={media.sizes.medium} alt={media.title} /> : null}
        </div>
        <div className="flex-fill px-4">
          <h5 className="mb-1">{shopProduct.name}</h5>
          <p className="text-muted"> {shopProduct.subname} </p>
          <div className="d-flex">
            <div className="flex-fill">
              <select
                className="form-control w-50 d-inline-block mr-4"
                name="parts"
                value={shopProduct.parts}
                onChange={(e) =>
                  this.handlePartsChange(
                    shopProduct.id,
                    parseInt(e.currentTarget.value)
                  )
                }
              >
                {[...Array(150).keys()].slice(1).map((f) => (
                  <option key={f} value={f}>
                    {f}
                  </option>
                ))}
              </select>
              {t("shopAdmin.parts").toLowerCase()}
            </div>
            <div className="flex-fill">
              <PriceInput
                className="form-control w-25 d-inline-block mr-4"
                name="priceSelling"
                value={shopProduct.priceSelling}
                onChange={(property: string, value: string) =>
                  this.handleUpdatePrice(shopProduct.id, property, value)
                }
              />
              {t("shopAdmin.totalPriceSelling").toLowerCase()}
            </div>
          </div>
        </div>
        <div style={{width: "40px", textAlign: "center"}}>
          {this.renderCheckbox(shopProduct.id)}
        </div>
      </div>
    )
  }

  renderAlreadyInShop() {
    const {t, shop, searchItem} = this.props
    const {items} = this.state
    /* console.log({items: items.map((i) => [i.id, i])})
    console.log({shopitems: shop.shopItems.find((si) => si.id == 223869)}) */
    const shopProductsInShop = shop.shopItems
      .filter((shopItem) => shopItem.shopProductId !== null)
      .map((shopItem) => {
        return {
          shopItem,
          shopProduct: items.find(
            (shopProduct) => shopProduct.id == shopItem.shopProductId
          ),
        }
      })
      .filter((obj) => obj.shopProduct !== undefined)
    const webshopSourceIntakeNotInvoiceInShop = shop.shopItems.filter(
      (shopItem) =>
        shopItem.babyListItems.some(
          (bli) => bli.webshopSource == "intake_not_invoiced"
        )
    )
    if (
      shopProductsInShop.length == 0 &&
      webshopSourceIntakeNotInvoiceInShop.length == 0
    )
      return null

    const totalShopProductsPriceInShop = shopProductsInShop.reduce(
      (acc, {shopItem}): any => {
        return toDinero(shopItem.priceSelling).multiply(shopItem.parts).add(acc)
      },
      toDinero("0")
    )
    /* console.log({webshopSource: searchItem.webshopSource})
    console.log(webshopSourceIntakeNotInvoiceInShop) */
    const totalwebshopSourceIntakeNotInvoicePriceInShop =
      searchItem.webshopSource == "bundling" &&
      webshopSourceIntakeNotInvoiceInShop.length
        ? webshopSourceIntakeNotInvoiceInShop.reduce(
            (acc, {priceSelling, parts, amount}): any => {
              return toDinero(priceSelling)
                .multiply(amount)
                .multiply(parts)
                .add(acc)
            },
            toDinero("0")
          )
        : toDinero("0")
    const totalPriceInShop = totalShopProductsPriceInShop.add(
      totalwebshopSourceIntakeNotInvoicePriceInShop
    )
    return (
      <>
        <h5 className="mt-4">{t("shopAdmin.shopProducts.alreadyAdded")}</h5>
        <ul>
          {shopProductsInShop.map(({shopProduct, shopItem}) => {
            const priceSelling = toDinero(shopItem.priceSelling).toFormat(
              "$0,0.00"
            )
            return (
              <li key={`ais-${shopProduct.id}-${shopItem.id}`}>
                {`${shopProduct.name} (${shopItem.parts} parts for ${priceSelling})`}
              </li>
            )
          })}
        </ul>
        {searchItem.webshopSource == "bundling" ? (
          <>
            <h5 className="mt-4">
              {t("shopAdmin.shopProducts.alreadyAddedWebshop")}
            </h5>
            <ul>
              {webshopSourceIntakeNotInvoiceInShop.map((shopItem) => {
                const priceSelling = toDinero(shopItem.priceSelling).toFormat(
                  "$0,0.00"
                )
                return (
                  <li key={`ais-${shopItem.id}`}>
                    {shopItem.parts > 1
                      ? `${shopItem.nameNl} (${shopItem.parts} parts for ${priceSelling})`
                      : `${shopItem.nameNl} (${shopItem.amount} for ${priceSelling})`}
                  </li>
                )
              })}
            </ul>
          </>
        ) : null}
        <div className="pl-4 ml-3">
          Total in shop: <strong>{totalPriceInShop.toFormat("$0,0.00")}</strong>
          <br />
          Product on intake:{" "}
          <strong>
            {toDinero(searchItem.priceSelling).toFormat("$0,0.00")}
          </strong>
        </div>
        <hr />
      </>
    )
  }

  render() {
    const {t, onClose, searchItem} = this.props
    const {items} = this.state
    return (
      <Modal
        className="modal-dialog modal-lg"
        isOpen={true}
        shouldCloseOnEsc={true}
        shouldCloseOnOverlayClick={true}
        onRequestClose={onClose}
        contentLabel={t("shopAdmin.shopProducts.title")}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t("shopAdmin.shopProducts.title")}</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label={t("modal.close")}
              onClick={onClose}
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>

          <div className="modal-body pt-0">
            <h4>{searchItem.name}</h4>
            {items.map(this.renderShopProduct)}
            <div className="d-flex justify-content-between mb-4">
              <div className="w-25"></div>
              <div className="flex-fill px-4"></div>
              <div style={{width: "60px", textAlign: "center"}}>
                <button
                  className="btn btn-primary"
                  type="button"
                  disabled={
                    items.filter((shopProduct) => shopProduct.selected)
                      .length == 0
                  }
                  onClick={this.handleSave}
                >
                  {t(`shopAdmin.modal.save`)}
                </button>
              </div>
            </div>

            <hr />

            {this.renderAlreadyInShop()}

            <button
              className="btn btn-secondary mt-4"
              type="button"
              onClick={onClose}
            >
              {t(`modal.close`)}
            </button>
          </div>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = (state: ReduxState) => ({
  shop: state.shop,
  babyToken: Config.data.babyToken,
})

export default withTranslation()(
  connect(mapStateToProps)(ShopAdminShopProductsModal)
)
